// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8aec29f4","455":"69363213","977":"f82dcb7b"}[chunkId] + ".chunk.js";
};